var _classCallCheck = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/circleci/project/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

/*
Instance of writable stream.

call .get(length) or .discard(length) to get a stream (relative to the last end)

emits 'stalled' once everything is written

*/
var _require = require('readable-stream'),
    Writable = _require.Writable,
    PassThrough = _require.PassThrough;

var RangeSliceStream = /*#__PURE__*/function (_Writable) {
  "use strict";

  _inherits(RangeSliceStream, _Writable);

  function RangeSliceStream(offset) {
    var _this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, RangeSliceStream);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeSliceStream).call(this, opts));
    _this.destroyed = false;
    _this._queue = [];
    _this._position = offset || 0;
    _this._cb = null;
    _this._buffer = null;
    _this._out = null;
    return _this;
  }

  _createClass(RangeSliceStream, [{
    key: "_write",
    value: function _write(chunk, encoding, cb) {
      var drained = true;

      while (true) {
        if (this.destroyed) {
          return;
        } // Wait for more queue entries


        if (this._queue.length === 0) {
          this._buffer = chunk;
          this._cb = cb;
          return;
        }

        this._buffer = null;
        var currRange = this._queue[0]; // Relative to the start of chunk, what data do we need?

        var writeStart = Math.max(currRange.start - this._position, 0);
        var writeEnd = currRange.end - this._position; // Check if we need to throw it all away

        if (writeStart >= chunk.length) {
          this._position += chunk.length;
          return cb(null);
        } // Check if we need to use it all


        var toWrite = void 0;

        if (writeEnd > chunk.length) {
          this._position += chunk.length;

          if (writeStart === 0) {
            toWrite = chunk;
          } else {
            toWrite = chunk.slice(writeStart);
          }

          drained = currRange.stream.write(toWrite) && drained;
          break;
        }

        this._position += writeEnd;
        toWrite = writeStart === 0 && writeEnd === chunk.length ? chunk : chunk.slice(writeStart, writeEnd);
        drained = currRange.stream.write(toWrite) && drained;

        if (currRange.last) {
          currRange.stream.end();
        }

        chunk = chunk.slice(writeEnd);

        this._queue.shift();
      }

      if (drained) {
        cb(null);
      } else {
        currRange.stream.once('drain', cb.bind(null, null));
      }
    }
  }, {
    key: "slice",
    value: function slice(ranges) {
      var _this2 = this;

      if (this.destroyed) return null;
      if (!Array.isArray(ranges)) ranges = [ranges];
      var str = new PassThrough();
      ranges.forEach(function (range, i) {
        _this2._queue.push({
          start: range.start,
          end: range.end,
          stream: str,
          last: i === ranges.length - 1
        });
      });

      if (this._buffer) {
        this._write(this._buffer, null, this._cb);
      }

      return str;
    }
  }, {
    key: "destroy",
    value: function destroy(err) {
      if (this.destroyed) return;
      this.destroyed = true;
      if (err) this.emit('error', err);
    }
  }]);

  return RangeSliceStream;
}(Writable);

module.exports = RangeSliceStream;